<template>
  <div class="purchase-list-award">
    <base-section-title v-if="showTitle" :title="title" class="m-b-24">
      <template v-slot:right-tool>
        <el-button
          v-if="showPdfBtn"
          type="primary"
          size="medium"
          class="flex-center m-b-10"
          @click="handleExportPdf"
        >
          导出pdf
        </el-button>
      </template>
    </base-section-title>
    <el-table
      ref="table"
      :data="tableData"
      border
      :header-cell-style="{ background: '#f5f5f5' }"
      :span-method="objectSpanMethod"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed="left"
      >
        <template slot-scope="{ row, $index }">
          <span>{{ indexNum(row, $index) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="品目信息" min-width="340px" fixed="left">
        <template slot-scope="{ row }">
          <div
            v-for="item in materielInfoConfig"
            :key="item.defineCode"
            class="info-item"
          >
            <span class="info-item-label">{{ item.columnName || '-' }}</span>
            <span
              v-if="item.columnName === '分类' && row.categoryNameTree"
              class="info-item-value"
            >
              {{ row.categoryNameTree.join('>') || '-' }}
            </span>
            <span v-else class="info-item-value">
              {{ row[item.defineCode] || '-' }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="采购量/计量单位" min-width="90px" fixed="left">
        <template slot-scope="{ row }">
          <span>
            {{ row[numConfig.defineCode] }}/{{ row[unitConfig.defineCode] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px" fixed="left" label="展开与收起">
        <template v-slot:header>
          <el-button
            type="text"
            :icon="isCollapse ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
            @click="isCollapse = !isCollapse"
          >
            {{ isCollapse ? '收起全部' : '展开查看更多' }}
          </el-button>
        </template>
        <template v-slot:default>
          <p>
            点击上方可{{
              isCollapse ? '收起' : '展开'
            }}查看参数型号、预算价格、备注等信息
          </p>
        </template>
      </el-table-column>
      <template v-if="isCollapse">
        <el-table-column
          :label="`预算单价(${isDollar ? '美元' : '元'})`"
          min-width="90px"
        >
          <template slot-scope="{ row }">
            <span>{{ row[unitPriceConfig.defineCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="`预算总价(${isDollar ? '美元' : '元'})`"
          min-width="90px"
        >
          <template slot-scope="{ row }">
            <span>{{ row.totalPrice }}</span>
            <money-in-cn v-if="!isDollar" :money="row.totalPrice || 0" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="controlPriceConfig.isEnable"
          :label="
            `${controlPriceConfig.columnName.replace('（元）', '')}(${
              isDollar ? '美元' : '元'
            })`
          "
          min-width="90px"
        >
          <template slot-scope="{ row }">
            <span>{{ row.controlPrice }}</span>
            <money-in-cn v-if="!isDollar" :money="row.controlPrice || 0" />
          </template>
        </el-table-column>
        <el-table-column v-if="modelConfig.isEnable" label="参数型号">
          <template slot-scope="{ row }">
            <span>{{ row[modelConfig.defineCode] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对供应商备注" min-width="90px">
          <template slot-scope="{ row }">
            <span>{{ row.remarks || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内部备注" min-width="90px">
          <template slot-scope="{ row }">
            <span>{{ row.insideRemark || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="附件" min-width="160px">
          <template slot-scope="{ row }">
            <upload
              v-if="row.attachmentFileIds && row.attachmentFileIds[0]"
              :props-data="{
                disabled: true,
                uploadMode: 'fileId',
                fileIdBefore: row.attachmentFileIds[0]
              }"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="采购人指定" min-width="340px">
          <template slot-scope="{ row }">
            <div
              v-for="item in purchaseSpecifyConfig"
              :key="item.defineCode"
              class="info-item"
            >
              <span class="info-item-label">{{ item.columnName || '-' }}</span>
              <span class="info-item-value">
                {{ row[item.defineCode] || '-' }}
              </span>
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column :label="title">
        <el-table-column label="供应商名称" min-width="130">
          <template slot-scope="{ row }">
            <span>{{ row.supplierName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showOfferTotalPrice"
          header-align="center"
          :label="`中标总价（${isDollar ? '美元' : '元'}）`"
        >
          <template slot-scope="{ row }">
            <span>
              {{
                row.bargainAmount
                  ? strToThousands(row.bargainAmount)
                  : strToThousands(row.awardAmount)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          :label="
            `${requireTax ? '含税价' : '未含税价'}(${isDollar ? '美元' : '元'})`
          "
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.offerPrice ? strToThousands(row.offerPrice) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showBargainAmount"
          header-align="center"
          label="议价（元）"
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.bargainAmount ? strToThousands(row.bargainAmount) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column v-if="requireTax" header-align="center" label="税率">
          <template slot-scope="{ row }">
            <span>
              {{ row.offerTaxRate ? strToThousands(row.offerTaxRate) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" label="授标数量">
          <template slot-scope="{ row }">
            <span>
              {{ row.num ? strToThousands(row.num) : '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in supplierResponseConfig"
          :key="item.defineCode"
          :label="item.columnName"
        >
          <template slot-scope="{ row }">
            <span>{{ row[item.defineCode] || '-' }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import Upload from '@/components/common/Upload'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具
import { strToThousands } from '@/utils/utils'
import { watermarkTypeDict } from '@/dictionary/template'
import { getFileUrlByFileIdApi, htmlToPdfApi } from '@/api/up-file'
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'
import { cloneDeep } from 'lodash'
import { generateMaterielHtml } from './generate-materiel-html'

/**
 * @description 采购清单授标结果组件
 */
export default {
  name: 'PurchaseListAward',

  components: { BaseSectionTitle, Upload, MoneyInCn },

  mixins: [materialColumnMixin],

  props: {
    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 是否含税
    requireTax: {
      type: Boolean,
      default: true
    },

    // 是否展示标题
    showTitle: {
      type: Boolean,
      default: true
    },

    // 是否展示下载按钮
    showPdfBtn: {
      type: Boolean,
      default: true
    },

    // 标题名称
    title: {
      type: String,
      default: '候选供应商'
    },

    // pdf文件名称
    pdfName: {
      type: String,
      default: '询比候选表'
    },

    // 获取pdf的数据api
    pdfApi: {
      type: Function,
      default: () => {}
    },

    // 是否显示中标总价
    showOfferTotalPrice: {
      type: Boolean,
      default: false
    },

    // 是否显示议价
    showBargainAmount: {
      type: Boolean,
      default: false
    },

    // 跨越行数对象，key为品目id，value为当前品目需要跨越的行数
    spanNumObj: {
      type: Object,
      default: () => {}
    },

    idField: {
      type: String,
      default: 'materielId'
    },

    // 是否是美元
    isDollar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 是否展开
      isCollapse: false
    }
  },

  computed: {
    indexNum() {
      return (row, index) => {
        return this.spanNumObj[row.materielId]?.index || 1
      }
    }
  },

  watch: {
    itemSchemaList: {
      handler(val) {
        if (val.length > 0) {
          this.columnConfig = cloneDeep(val)
          this.setTableConfig()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    strToThousands,

    // 下载pdf
    async handleExportPdf() {
      const pdfData = await this.getPdfData()
      const tableHtml = generateMaterielHtml({
        pdfData,
        pdfTitle: this.pdfName,
        isDollar: this.isDollar,
        title: this.title,
        requireTax: this.requireTax,
        showBargainAmount: this.showBargainAmount,
        showOfferTotalPrice: this.showOfferTotalPrice
      })
      this.downloadPdf(tableHtml)
    },

    // 获取比价表pdf数据
    getPdfData() {
      return new Promise((resolve, reject) => {
        this.pdfApi()
          .then(res => {
            const data = res?.data || {}
            resolve(data)
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
            throw err
          })
      })
    },

    // 下载pdf
    downloadPdf(content) {
      const postData = {
        name: `${this.pdfName}.pdf`,
        watermark: {
          watermarkType: watermarkTypeDict.ORDINARY_TEXT.value, // 水印类型
          watermarkWord: '精彩纵横云采购平台'
        },
        content: content
      }
      htmlToPdfApi(postData)
        .then(res => {
          getFileUrlByFileIdApi({ attachmentId: res.data }).then(fileRes => {
            window.open(fileRes.data.external, '_self')
          })
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 以收取展开列的下标为开始，以供应商名称的下标为结束，生成中间需要跨行展示的列号数组
      const START_INDEX = this.$refs.table.columns.findIndex(
        item => item.label === '展开与收起'
      )
      const END_INDEX = this.$refs.table.columns.findIndex(
        item => item.label === '供应商名称'
      )
      const defaultColumnIndexArray = [...Array(START_INDEX + 1).keys()]
      const expandColumnIndexArray = this.isCollapse
        ? [...Array(END_INDEX).keys()].slice(START_INDEX)
        : []
      const columnIndexArray = [
        ...defaultColumnIndexArray,
        ...expandColumnIndexArray
      ]

      const tempObj = this.spanNumObj[row[this.idField]]
      const spanNum = tempObj.num || 1

      if (columnIndexArray.indexOf(columnIndex) > -1) {
        if (rowIndex === tempObj.start) {
          return {
            rowspan: spanNum,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-item {
  display: flex;
  align-items: stretch;
  margin: 24px 0;
  line-height: 22px;

  &:first-child {
    margin-top: 16px;
  }
  &:last-child {
    margin-bottom: 16px;
  }

  .info-item-label {
    color: $text-color;
    width: 40%;
    margin-right: 24px;
    font-weight: bold;
  }
  .info-item-value {
    flex: 1;
    color: $second-text-color;
  }
}
</style>
